import * as React from "react";
import { Link } from "react-router-dom";
import { SyntheticEvent } from "react";
import RaisedButton from "material-ui/RaisedButton";
import Popover from "material-ui/Popover";
import Menu from "material-ui/Menu";
import MenuItem from "material-ui/MenuItem";
import { success, white } from "../../colors";

const buttonStyle = {
    labelColor: white,
    backgroundColor: success,
};
const popoverStyle = {
    backgroundColor: success,
    color: white
};
const menuItemStyle = {
    color: white
};

interface DeployButtonProps {
    defaultLabel: string;
    items: Array<{ label: string, link: string }>;
    onClick?(): void;
}

interface DeployButtonState {
    open: boolean;
    anchor: EventTarget;
}

export class NextButton extends React.Component<DeployButtonProps, DeployButtonState> {
    constructor(props: DeployButtonProps) {
        super(props);

        this.state = {
            open: false,
            anchor: null
        };
    }

    render() {
        if (this.props.items.length === 0) {
            return null;
        }

        if (this.props.items.length > 1) {
            const popover = (
                <Popover
                    open={this.state.open}
                    style={popoverStyle}
                    canAutoPosition={true}
                    anchorEl={this.state.anchor as any}
                    anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
                    targetOrigin={{ horizontal: "left", vertical: "top" }}
                    onRequestClose={this.handleRequestClose}>
                    <Menu>
                        {this.props.items.map(item =>
                            <Link key={item.label} to={{ pathname: item.link }} onClick={this.props.onClick}>
                                <MenuItem primaryText={item.label} style={menuItemStyle} onClick={this.handleRequestClose} />
                            </Link>
                        )}
                    </Menu>
                </Popover>
            );

            return (
                <div>
                    <RaisedButton
                        {...buttonStyle}
                        style={{margin: "0.5rem"}}
                        label={this.props.defaultLabel}
                        labelPosition="before"
                        icon={<i className="fa fa-caret-down" style={{ color: white }} />}
                        onClick={this.handleTouchTap}
                    />
                    {popover}
                </div>
            );
        }

        return (
            <Link to={{ pathname: this.props.items[0].link }} onClick={this.props.onClick}>
                <RaisedButton
                    {...buttonStyle}
                    style={{margin: "0.5rem"}}
                    label={this.props.defaultLabel}
                />
            </Link>
        );
    }

    private handleTouchTap = (event: React.SyntheticEvent<{}>) => {
        event.preventDefault();

        this.setState({
            open: true,
            anchor: event.currentTarget
        });
    }

    private handleRequestClose = () => {
        this.setState({
            open: false
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/GettingStarted/NextButton.tsx